import { calc, mapResponsive, useTheme } from '@hover/blueprint';

import { useViewportSize } from 'src/modules/homeownerApp/hooks/useViewportSize';
import { useIsEmbed } from 'src/shared/hooks';

interface EmbedViewportSizeProps {
  fromSample?: boolean;
}

export const useEmbedViewportSize = ({
  fromSample, // TODO: remove when realtor poc is deprecated https://hoverinc.atlassian.net/browse/MEOW-5669
}: EmbedViewportSizeProps) => {
  const { sizes } = useTheme();
  const isEmbed = useIsEmbed();
  const { height: viewportHeight } = useViewportSize();
  const embedFooterHeight = { base: sizes[600], tablet: '90px' } as const;
  const embedViewportHeight = mapResponsive(
    footerHeight => calc.subtract(viewportHeight, footerHeight),
    embedFooterHeight,
  ) as typeof embedFooterHeight;

  return {
    height:
      isEmbed && fromSample
        ? embedViewportHeight
        : { base: viewportHeight, tablet: viewportHeight },
    embedFooterHeight,
  };
};
